import appboy from 'appboy-web-sdk';

import config from 'src/config';

class AppBoyClient {
  init() { //eslint-disable-line
    appboy.initialize(config.BRAZE_API_KEY, {
      enableLogging: config.NODE_ENV !== 'production',
      baseUrl: 'https://customer.iad-03.braze.com/api/v3'
    });
    appboy.display.automaticallyShowNewInAppMessages();
    appboy.openSession();
  }

  stopWebTracking() { //eslint-disable-line
    appboy.stopWebTracking();
  }

  resumeWebTracking() { //eslint-disable-line
    appboy.resumeWebTracking();
  }

  identify(user) { //eslint-disable-line
    appboy.changeUser(user.id);

    appboy.getUser().setEmail(user.email);
  }

  track(eventName, eventData) { //eslint-disable-line
    appboy.logCustomEvent(eventName, eventData);
  }
}

export default new AppBoyClient();



// WEBPACK FOOTER //
// ./src/services/appboy.js